import React, { useState } from 'react';
import i18n from 'i18n/config';
import spainFlag from 'img/flags/Spain';
import ukFlag from 'img/flags/UnitedKingdom';
import franceFlag from 'img/flags/France';
import mexicoFlag from 'img/flags/Mexico';
import chinaFlag from 'img/flags/China';
import styled from 'styled-components';
import { CircleFlag as BaseFlag } from 'react-circle-flags';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const FlagIcon = styled(BaseFlag)`
  img {
    ${({ active }) =>
      !active &&
      `
      filter: grayscale(1);
      -webkit-filter: grayscale(1);
      transition: all .2s ease-in-out;
    `}
    &:hover {
      filter: none;
      -webkit-filter: grayscale(0);
      transform: scale(1.01);
    }
  }
`;

const LanguageSwitcher = ({ en = true, es = true, es_mx = true, fr = false, zh = false, urls }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const host = window.location.host;
  const isMexicoDomain = host.includes('.mx');

  const redirectToLanguage = (code) => {
    window.location.href = urls[code];
  };

  const flagCode = (code) => {
    if (code === 'en') return isMexicoDomain ? 'us' : 'gb';
    if (code === 'es_mx') return 'mx';
    if (code === 'zh') return 'cn';
    return code;
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
      <DropdownToggle tag="div" className="p-0" style={{ cursor: 'pointer' }}>
        <FlagIcon countryCode={flagCode(i18n.language)} height="23" className="me-1" />
        <small>
          <span className="language-code d-inline p-0 nav-link text-white text-uppercase fw-bold">
            {i18n.language.split('_')[0]}
          </span>
        </small>
      </DropdownToggle>

      <DropdownMenu style={{ width: '100%' }}>
        {es && !isMexicoDomain && (
          <DropdownItem onClick={() => redirectToLanguage('es')}>
            <FlagIcon countryCode="es" height="23" className="me-1" /> Español
          </DropdownItem>
        )}

        {es_mx && isMexicoDomain && (
          <DropdownItem onClick={() => redirectToLanguage('es_mx')}>
            <FlagIcon countryCode="mx" height="23" className="me-1" /> Español
          </DropdownItem>
        )}

        {en && (
          <>
            <DropdownItem divider />
            <DropdownItem onClick={() => redirectToLanguage('en')}>
              <FlagIcon countryCode={isMexicoDomain ? 'us' : 'gb'} height="23" className="me-1" /> English
            </DropdownItem>
          </>
        )}

        {fr && (
          <>
            <DropdownItem divider />
            <DropdownItem onClick={() => redirectToLanguage('fr')}>
              <FlagIcon countryCode="fr" height="23" className="me-1" /> Français
            </DropdownItem>
          </>
        )}

        {zh && (
          <>
            <DropdownItem divider />
            <DropdownItem onClick={() => redirectToLanguage('zh')}>
              <FlagIcon countryCode="cn" height="23" className="me-1" /> 汉语
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageSwitcher
